export const tableKeysHelper = [
  {
    key: "ProfilePicture",
    order: false,
    css: "profile-picture",
    type: "profile-picture",
  },
  {
    text: "table-header-email",
    key: "Email",
    css: "email",
  },
  {
    text: "table-header-fullname",
    key: "FullName",
    css: "fullname",
    order: false,
  },
  {
    text: "table-header-creationdate",
    key: "Creation",
    css: "creationdate",
    type: "date"
  },
  {
    text: "table-header-lastlogin",
    key: "LastLogin",
    css: "lastlogin",
    type: "date",
  },
  {
    text: "table-header-permission",
    key: "Permission",
    css: "permission",
  },
  {
    text: "table-header-status",
    key: "Status",
    css: "status",
  },
  {
    text: "table-header-usedsize",
    key: "UsedSize",
    css: "usedsize",
    type: "sizeWithPrecenteges",
  },
  {
    text: "table-header-actions",
    key: "Custom",
    type: "custom",
    css: "actions",
    order: false,
  },
];
export const tableKeysHelperForRemovedUsers = [
  {
    key: "RemovedUserProfilePicture",
    order: false,
    type: "profile-picture",
  },
  {
    text: "table-header-email",
    key: "RemovedUserEmail",
  },
  {
    text: "table-header-fullname",
    key: "RemovedUserName",
  },
  {
    text: "table-header-removal-date",
    key: "RemovalDate",
    type: "date",
  },
  {
    text: "table-header-remove-by",
    key: "RemovedUserByEmail",
  },
  {
    text: "table-header-status",
    key: "Status",
    order: false,
  },
];
